import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const SubTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  margin: 35px 0px 15px;
  color: #6c7488;
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export const FormWrapper = styled.div`
  font-size: 12px;
  background-color: #fff;
  margin-top: 25px;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  display: inline-block;
`;

export const DataLabel = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
`;

export const MultiColRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 15px 0;

  .col {
    flex: 1;
    flex-direction: row;
  }

  .label {
    color: #6c7488;
  }

  label {
    margin-bottom: 0px;
  }
`;

export const MultiColFormRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .col {
    flex: 1;
    flex-direction: row;
  }

  label {
    margin-bottom: 0px;
  }
`;

export const FormItem = styled.div`
  padding-bottom: 22px;
  font-weight: 300;
  color: #6c7488;
  position: relative;

  .error-msg {
    margin-left: 5px;
    color: red;
    font-size: 12px;
  }
  .fileUpload {
    display: none;
  }
  .uploadButton {
    display: block;
    margin-top: 30px;
    cursor: pointer;
    font-size: large;
  }
  .pending {
    font-style: italic;
  }
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-bottom: 5px;
`;

export const FeeStructExSelect = styled.select`
  justify-content: space-between;
  flex: 1;
  flex-direction: row;
  width: 35%;
  height: 25px;
  padding: 0.22rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-bottom: 5px;
  margin-left: 35%;
`;

export const CountrySelect = styled(FormControl)`
  width: 25%;
  margin-bottom: 20px;
`;

export const SpinnerWrapper = styled.span`
  display: inline;
  vertical-align: top;
  margin-left: 10px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}

export const VInput = styled(Input)<VInputProps>`
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  margin-bottom: 5px;
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const MerchantSettingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EditMerchantSettings = styled.button`
  color: blue;
  cursor: pointer;
  background: none;
  border: none;
  margin-right: 10px;
`;

export const MerchantSettingsView = styled.div`
  margin-top: 20px;
`;

export const MessageWrapper = styled.div`
  padding: 60px 0;
  text-align: center;
`;

export const FormCheckbox = styled.input`
  display: inline-block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-left: 20px;
`;

export const FeeStructEditor = styled.div`
  border: 1px solid #dce3eb;
  margin-bottom: 5px;
`;
